import * as j from '@mojotech/json-type-validation';

import { Agent } from '~pages/SystemManagement/domain';

export const GetAgentResponseDecoder: j.Decoder<Agent> = j
  .object({
    username: j.string(),
    full_name: j.string(),
    dialler_group_id: j.union(j.number(), j.constant(null)),
    dialler_group_name: j.union(j.string(), j.constant(null)),
    routing_profile_id: j.union(j.string(), j.constant(null)),
    disabled: j.union(j.string(), j.constant(null)),
    skills: j.array(j.string()),
    async_queues: j.array(j.string()),
    async_max_concurrency: j.number(),
    async_desired_concurrency: j.number(),
  })
  .map((item) => {
    const nameSplit = item.full_name.split(' ');

    return {
      username: item.username,
      fullName: item.full_name,
      firstName: nameSplit[0] || '',
      lastName: nameSplit[1] || '',
      diallerGroupId: item.dialler_group_id ?? 0,
      diallerGroupName: item.dialler_group_name ?? '',
      routingProfileId: item.routing_profile_id,
      disabled: Boolean(item.disabled),
      skills: item.skills,
      asyncQueues: item.async_queues,
      asyncMaxConcurrency: item.async_max_concurrency,
      asyncDesiredConcurrency: item.async_desired_concurrency,
    };
  });
